import React from 'react';
import { Link } from 'react-router-dom';
import FormattedDate from './FormattedDate';
import BookPage from './common/BookPage';
import MarkdownRenderer from './common/MarkdownRenderer';

interface BlogPostContentProps {
  title: string;
  content: string;
  publishedAt?: string | null;
  className?: string;
  children?: React.ReactNode;
}

const BlogPostContent: React.FC<BlogPostContentProps> = ({
  title,
  content,
  publishedAt,
  className = '',
  children,
}) => {
  return (
    <BookPage
      eyebrow="Thoughts"
      title={title}
      className={className}
      headerAside={
        <>
          <div className="uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">Published</div>
          <div className="mt-1 font-serif text-lg text-[color:var(--wf-plum)]">
            {publishedAt ? <FormattedDate date={publishedAt} /> : 'Draft'}
          </div>
        </>
      }
    >
      <div className="text-sm text-[color:var(--wf-ink-soft)]">
        <Link to="/blog" className="transition-colors duration-200 hover:text-[color:var(--wf-plum)]">
          ← Back to Thoughts
        </Link>
      </div>

      <div className="mt-8 text-[color:var(--wf-ink)]">
        <MarkdownRenderer content={content} />
      </div>

      {children && <div className="mt-10 border-t border-[color:var(--wf-border)] pt-8">{children}</div>}
    </BookPage>
  );
};

export default BlogPostContent;
